import type {PermissionsRecordType} from '../permissions';

export const dataGridPermissions = {
  customSharePreset: {
    actionId: 'SHARE',
    resourceId: 'CUSTOM_PRESET',
    scopes: [],
  },
} satisfies PermissionsRecordType;
